import { useEffect, useState } from "react";
import PackageCard from "@/components/PackageCard";
import useReveal from "@/hooks/useReveal";
import { fetchPackages } from "@/lib/api";

export default function Packages() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  useReveal([packages.length, loading]);

  useEffect(() => {
    fetchPackages()
      .then((data) => setPackages(data))
      .catch(() => setPackages([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="packages-page" className="pt-28 md:pt-32 min-h-screen">
      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-12 md:pb-16">
        <div className="reveal max-w-3xl">
          <p className="eyebrow mb-4">Curated Itineraries · 8 Journeys</p>
          <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-[#1F3A5F] leading-[1.05]">
            Ladakh, the way it should be experienced.
          </h1>
          <p className="mt-6 text-[#5A6B82] leading-relaxed text-base sm:text-lg max-w-2xl">
            From a 5-day glimpse to a 9-day expedition across the world's
            highest passes — every itinerary is built by travel veterans, paced
            for altitude, and designed to feel personal.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-20 md:pb-28">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="aspect-[4/5] bg-[#1F3A5F]/5 animate-pulse" />
            ))}
          </div>
        ) : (
          <div
            data-testid="packages-grid"
            className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 reveal"
          >
            {packages.map((p) => (
              <PackageCard key={p.slug} pkg={p} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
